module.exports = __webpack_public_path__ + "5e4abd7b6ea05406f2c1ef802278e3b3.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/Lankenau2.jpg
// module id = 620
// module chunks = 0